import { theme } from 'antd';
/**
 * 从 global.css 的设计令牌读取颜色值，保证 TypeScript 侧与样式令牌同源。
 * @param name CSS 自定义属性名，例如 `--color-brand-500`。
 * @returns 令牌当前值；非浏览器环境或令牌缺失时返回空字符串。
 */
function readColorToken(name) {
    if (typeof window === 'undefined')
        return '';
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
/**
 * 构建全局 Ant Design 暗色主题。
 *
 * 影游工作台为中性深灰配色，antd 组件统一走 darkAlgorithm，
 * 品牌色与语义色对齐 `src/styles/global.css` 中的令牌定义；
 * 令牌读取失败（如单测 jsdom 环境）时保持 antd 默认值，不影响组件行为。
 */
export function buildAntdTheme() {
    const brandColor = readColorToken('--color-brand-500');
    const brandFocus = readColorToken('--color-brand-focus');
    const errorColor = readColorToken('--color-error');
    return {
        algorithm: theme.darkAlgorithm,
        token: {
            ...(brandColor
                ? { colorPrimary: brandColor, colorInfo: brandColor, colorLink: brandColor }
                : {}),
            ...(errorColor ? { colorError: errorColor } : {}),
            borderRadius: 8,
            ...(brandFocus ? { controlOutline: brandFocus } : {}),
        },
    };
}
